const ExerciseStatuses = {
  UNTOUCHED: 0,
  TOUCHED: 1,
  CORRECT: 2,
  WRONG: 3,
};

export default ExerciseStatuses;
